import isObject from 'lodash/isObject';
import { LinkProps } from 'next/link';
import { UrlObject } from 'url';

interface LinkData {
  href: UrlObject;
  queryPageKey: string;
}

const getPaginationHrefConstructor =
  (linkData: LinkData) =>
  (page: number): LinkProps['href'] => ({
    ...linkData.href,
    query: { ...(isObject(linkData.href.query) ? linkData.href.query : {}), [linkData.queryPageKey]: page },
  });

export default getPaginationHrefConstructor;
